import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FirebaseContext } from "../contexts/FirebaseContext";
import TopBar from "../components/TopBar";
import { ReactComponent as BackIcon } from "../assets/icon_back.svg";
import Colors from "../constants/Colors";

const DANGER = "#e5484d";

function ClientsScreen() {
  const navigate = useNavigate();
  const { clients, createClient, updateClient, deleteClient } = useContext(FirebaseContext);

  // editing: null = list view; { id, name, address, taxId } = form view (new if id == null)
  const [editing, setEditing] = useState(null);

  const openNew = () => setEditing({ id: null, name: "", address: "", taxId: "" });
  const openEdit = (c) => setEditing({ id: c.id, name: c.name || "", address: c.address || "", taxId: c.taxId || "" });

  const save = async () => {
    const name = (editing.name || "").trim();
    if (!name) return;
    if (editing.id == null) {
      await createClient(name, editing.address, editing.taxId);
    } else {
      await updateClient(editing.id, { name, address: editing.address, taxId: editing.taxId });
    }
    setEditing(null);
  };

  const remove = async () => {
    if (editing.id == null) return setEditing(null);
    if (window.confirm("Delete this client?")) {
      await deleteClient(editing.id);
      setEditing(null);
    }
  };

  // ── Form view ──
  if (editing) {
    return (
      <div style={styles.container}>
        <TopBar
          leftContainer={
            <button onClick={() => setEditing(null)} style={styles.backBtn} aria-label="Back">
              <BackIcon style={{ width: 22, height: 22, fill: "var(--text)" }} />
            </button>
          }
          centerContainer={<span style={styles.headerTitle}>{editing.id == null ? "New client" : "Edit client"}</span>}
        />
        <div style={styles.body}>
          <label style={styles.label}>Name</label>
          <input style={styles.input} value={editing.name} onChange={(e) => setEditing((s) => ({ ...s, name: e.target.value }))} autoFocus />
          <label style={styles.label}>Address</label>
          <textarea style={{ ...styles.input, minHeight: "70px", resize: "vertical" }} value={editing.address} onChange={(e) => setEditing((s) => ({ ...s, address: e.target.value }))} />
          <label style={styles.label}>Tax ID</label>
          <input style={styles.input} value={editing.taxId} onChange={(e) => setEditing((s) => ({ ...s, taxId: e.target.value }))} />
          {editing.id != null && (
            <button style={styles.deleteBtn} onClick={remove}>Delete client</button>
          )}
        </div>
        <div style={styles.ctaBar}>
          <button style={{ ...styles.primaryCta, opacity: editing.name.trim() ? 1 : 0.5 }} disabled={!editing.name.trim()} onClick={save}>
            Save
          </button>
        </div>
      </div>
    );
  }

  // ── List view ──
  return (
    <div style={styles.container}>
      <TopBar
        leftContainer={
          <button onClick={() => navigate("/invoice")} style={styles.backBtn} aria-label="Back">
            <BackIcon style={{ width: 22, height: 22, fill: "var(--text)" }} />
          </button>
        }
        centerContainer={<span style={styles.headerTitle}>Clients</span>}
      />
      <div style={styles.body}>
        {clients.length === 0 && <div style={styles.empty}>No clients yet.</div>}
        {clients.map((c) => (
          <div key={c.id} style={styles.row} onClick={() => openEdit(c)}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={styles.rowTitle}>{c.name || "(no name)"}</div>
              {c.taxId ? <div style={styles.rowSub}>Tax ID: {c.taxId}</div> : null}
            </div>
            <span style={styles.chevron}>›</span>
          </div>
        ))}
      </div>
      <div style={styles.ctaBar}>
        <button style={styles.primaryCta} onClick={openNew}>New Client</button>
      </div>
    </div>
  );
}

const styles = {
  container: { paddingTop: "50px", height: "calc(100vh - 60px)", boxSizing: "border-box" },
  backBtn: { background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", padding: 0 },
  headerTitle: { fontWeight: 700 },
  body: { padding: "16px", paddingBottom: "90px", maxWidth: "560px", margin: "0 auto", height: "100%", overflowY: "auto", boxSizing: "border-box" },
  empty: { color: "var(--text-muted)", fontSize: "14px" },
  row: { display: "flex", alignItems: "center", gap: "10px", padding: "12px 14px", marginBottom: "8px", borderRadius: "10px", background: "var(--card)", cursor: "pointer" },
  rowTitle: { color: "var(--text)", fontSize: "15px", fontWeight: 600 },
  rowSub: { color: "var(--text-muted)", fontSize: "12px", marginTop: "2px" },
  chevron: { color: "var(--text-muted)", fontSize: "20px" },
  label: { fontSize: "12px", color: "var(--text-muted)", margin: "12px 0 4px", display: "block" },
  input: { padding: "10px", borderRadius: "8px", border: "1px solid var(--border)", background: "var(--surface)", color: "var(--text)", fontSize: "14px", width: "100%", boxSizing: "border-box" },
  deleteBtn: { background: "none", border: "none", color: DANGER, fontWeight: 700, cursor: "pointer", padding: "16px 0" },
  ctaBar: { position: "fixed", left: 0, right: 0, bottom: "60px", padding: "12px 16px", background: "var(--bg)", borderTop: "1px solid var(--border)", boxSizing: "border-box" },
  primaryCta: { width: "100%", padding: "12px", background: Colors.primary, color: "#fff", border: "none", borderRadius: "10px", fontWeight: 700, cursor: "pointer" },
};

export default ClientsScreen;
